import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { RootState } from "../../redux/store";
import { Paths } from "../../common/constants";
import { isValidMongoId } from "../../common/utils";
import { getCoAChainDetail } from "./services/action";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";

const useBlockChainCoADetailsHelper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const pathName = location.pathname.split("/");
  const _id = pathName[pathName.length - 1];

  const { productChainDetails } = useAppSelector(
    (state: RootState) => state.productCoASlice,
  );

  useEffect(() => {
    if (_id && isValidMongoId(_id)) {
      dispatch(getCoAChainDetail(_id));
    } else {
      navigate(Paths.NOT_FOUND);
    }
    // eslint-disable-next-line
  }, [_id]);

  return { productChainDetails };
};

export default useBlockChainCoADetailsHelper;
